import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { cache, createQuery, localStorageCache } from '@farfetched/core';
import { signout } from '@features/common';
import * as api from './api';
import type { AccessGroupsResponse } from './types';

export const AccessGroupsGate = createGate();

const fxGetList = createEffect<void, AccessGroupsResponse, Error>().use(api.getList);

export const accessGroupsQuery = createQuery({
  name: 'get-access-groups',
  effect: fxGetList,
  mapData: ({ result }) => {
    if (Array.isArray(result?.groups) && result.groups.length > 0) {
      return result.groups.map(({ id, title: label }) => ({ id, label }));
    }
    return [];
  },
});

cache(accessGroupsQuery, {
  adapter: localStorageCache({ maxAge: '5m' }),
  purge: signout,
});

sample({
  clock: AccessGroupsGate.state,
  target: accessGroupsQuery.start,
});
